export default class BShowtoggle
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.b-showtoggle`;

	static initialize()
	{
		this.addEventListeners();

		document.querySelectorAll(this.selector()).forEach(el => {
			(new this(el)).refresh();
		});
	}

	static addEventListeners()
	{
		document.addEventListener('change', event => {
			if (event.target.matches(`[data-showtoggle-set]`)) {
				let showtoggle = new this(event.target.closest(this.selector()));

				showtoggle.refresh();
			}
		});
	}

	getState()
	{
		let state = {};

		this.el.querySelectorAll('[data-showtoggle-set]').forEach(el => {
			if (el?.checked) {
				let explicit = el.dataset?.showtoggleSet?.trim();
				if (explicit.length) {
					let [name, value] = explicit.split(":");
					state[name] = value;
				} else {
					state[el.name] = el.value;
				}
			}
		});

		return state;
	}

	refresh()
	{
		const state = this.getState();

		this.el.querySelectorAll('[data-showtoggle-if]').forEach(el => {
			el.removeAttribute('hidden');
			for (let condition of el.dataset.showtoggleIf.split(" ")) {
				let [name, value] = condition.split(":");
				if (state[name] != value) {
					el.setAttribute('hidden', true);
				}
			}
		});
	}
}
